import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ClipboardList, GraduationCap, ArrowDown } from 'lucide-react';
export function SolutionIntro() {
  const cards = [{
    icon: <BookOpen className="w-8 h-8 text-[#1B4332]" data-id="element-248" />,
    title: '📖 Comer sin Miedo',
    subtitle: 'Tu guía para comer con libertad y sin culpa',
    description: 'Aprendé qué alimentos son tus aliados, cómo combinarlos y cómo disfrutar de la comida sin que tu glucosa se descontrole. Sin listas de prohibidos — con estrategias reales.'
  }, {
    icon: <ClipboardList className="w-8 h-8 text-[#1B4332]" data-id="element-249" />,
    title: '📋 Diabetes en Orden',
    subtitle: 'El sistema para organizar tu día a día',
    description: 'Rutinas, horarios, control de medicación y seguimiento de glucosa en un solo lugar. Dejá de improvisar y empezá a tener el control de tu manejo diario.'
  }, {
    icon: <GraduationCap className="w-8 h-8 text-[#1B4332]" data-id="element-250" />,
    title: '🎓 Lo Esencial sobre la Diabetes',
    subtitle: 'Entendé tu condición de una vez por todas',
    description: 'Sin jerga médica. Explicaciones claras sobre qué pasa en tu cuerpo, por qué importa lo que comés y cómo tomar mejores decisiones cada día.'
  }];
  return <section className="py-20 px-4 bg-gradient-to-b from-[#FEFBF4] to-[#E6F4EA]/30" data-id="element-251">
      <div className="max-w-7xl mx-auto" data-id="element-252">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-253">
          <span className="text-[#1B4332] font-semibold tracking-wide uppercase text-sm bg-[#86EFAC]/30 px-3 py-1 rounded-full" data-id="element-254">
            La solución
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B4332] mt-6 mb-6" data-id="element-255">
            Un Sistema Completo Para Manejar Tu Diabetes Con Confianza — No Con
            Miedo
          </h2>
          <p className="text-lg text-[#1C1917]/80" data-id="element-256">
            Imaginate abrir la heladera y saber exactamente qué preparar. Ir al
            supermercado con una lista clara. Sentarte a comer en un restaurante
            sin ansiedad. Eso es lo que este pack hace por vos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-257">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-[#1B4332]/5 hover:shadow-xl transition-shadow duration-300 flex flex-col" data-id="element-258">
              <div className="bg-[#E6F4EA] w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-259">
                {card.icon}
              </div>
              <h3 className="text-xl font-bold text-[#1B4332] mb-2" data-id="element-260">
                {card.title}
              </h3>
              <p className="text-[#D97706] font-medium text-sm mb-4" data-id="element-261">
                {card.subtitle}
              </p>
              <p className="text-[#1C1917]/70 leading-relaxed flex-grow" data-id="element-262">
                {card.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="text-center mt-16" data-id="element-263">
          <p className="text-xl font-medium text-[#1B4332] flex flex-col items-center gap-2" data-id="element-264">
            Pero eso es solo el comienzo...
            <ArrowDown className="w-6 h-6 animate-bounce text-[#D97706]" data-id="element-265" />
          </p>
        </motion.div>
      </div>
    </section>;
}